import { getUserDataFromLocal } from "./utils";

export const hasPermission = (moduleName, action = "view") => {
  const adminData = getUserDataFromLocal();
  if (!adminData) return false;

  // Super admin → full access
  if (Number(adminData.admin_id) === 0) return true;

  const permission = adminData.permission?.find(
    (perm) => perm.permission_module?.name === moduleName
  );

  if (!permission) return false;

  switch (action) {
    case "view":
      return Number(permission.is_view) === 1;
    case "add":
      return Number(permission.is_add) === 1;
    case "edit":
      return Number(permission.is_edit) === 1;
    case "delete":
      return Number(permission.is_delete) === 1;
    case "status":
      return Number(permission.is_status) === 1;
    default:
      return false;
  }
};
